import * as Utils from 'Assets/Utils'

import Immutable from 'immutable'
import ClientHttpRequest from 'Api/ClientHttpRequest'
import { createModal } from 'Modules/Modal'
import { isLoading } from 'Modules/Loading'

const initialState = Immutable.Map({})
	.set('GetIntervention', new Immutable.Map({}))
	.set('Get', new Immutable.List([]))
	.set('Stage', new Immutable.Map({ etapas: { etapa: [] } }))
	.set('Knowledge', new Immutable.List([]))
	.set('Objectives', new Immutable.Map({ objetivos: { objetivo: [] }, porcentajeAvancePlanTrabajo: 0, porcentajeValidacionEntregables: 0 }))
	.set('Save', new Immutable.Map({}))
	.set('SaveGlobal', new Immutable.List([]))
	.set('Send', new Immutable.List([]))
	.set('Close', new Immutable.List([]))
	.set('Delete', new Immutable.Map({}))

/*Types*/
export const ACTION_GET_INTERVENTION_LEVEL = 'ACTION_GET_INTERVENTION_LEVEL'
export const ACTION_GET_TYPE = 'ACTION_GET_TYPE'
export const ACTION_GET_STAGE = 'ACTION_GET_STAGE'
export const ACTION_GET_KNOWLEDGE = 'ACTION_GET_KNOWLEDGE'
export const ACTION_GET_OBJECTIVES = 'ACTION_GET_OBJECTIVES'
export const ACTION_SAVE_DATA = 'ACTION_SAVE_DATA'
export const ACTION_SAVE_GLOBAL = 'ACTION_SAVE_GLOBAL'
export const ACTION_SEND_MAIL = 'ACTION_SEND_MAIL'
export const ACTION_CLOSE_PROCESS = 'ACTION_CLOSE_PROCESS'
export const ACTION_DELETE_DATA = 'ACTION_DELETE_DATA'

/*Reducer*/

export default (state = initialState, action) => {
	switch (action.type) {
		case ACTION_GET_INTERVENTION_LEVEL:
			return state.set('GetIntervention', new Immutable.Map(action.Obj))
		case ACTION_GET_TYPE:
			return state.set('Get', new Immutable.List(action.Obj))
		case ACTION_GET_STAGE:
			return state.set('Stage', new Immutable.Map(action.Obj))
		case ACTION_GET_KNOWLEDGE:
			return state.set('Knowledge', new Immutable.List(action.Obj))
		case ACTION_GET_OBJECTIVES:
			return state.set('Objectives', new Immutable.Map(action.Obj))
		case ACTION_SAVE_DATA:
			return state.set('Save', new Immutable.Map(action.Obj))
		case ACTION_SAVE_GLOBAL:
			return state.set('SaveGlobal', new Immutable.List(action.Obj))
		case ACTION_SEND_MAIL:
			return state.set('Send', new Immutable.List(action.Obj))
		case ACTION_CLOSE_PROCESS:
			return state.set('Close', new Immutable.List(action.Obj))
		case ACTION_DELETE_DATA:
			return state.set('Delete', new Immutable.Map(action.Obj))
		default:
			return state
	}
}

/*Action Creators*/

export const monitoringInterventionLevel = (idDonataria) => {

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getInterventionLevelMonitoring',
			method: 'POST',
			data: { idDonataria },
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_INTERVENTION_LEVEL, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getType = () => {
	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getType',
			method: 'POST',
			data: {},
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_TYPE, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getStage = (form) => {
	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getStage',
			method: 'POST',
			data: { ...form },
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, 'uid': sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_STAGE, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getKnowledge = () => {
	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getKnowledge',
			method: 'POST',
			data: {},
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_GET_KNOWLEDGE, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getObjectives = (form) => {
	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getObjectives',
			method: 'POST',
			data: { ...form },
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, 'uid': sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			response.data.uniqueId = Utils.getUUID()
			dispatch({ type: ACTION_GET_OBJECTIVES, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}

}

export const saveData = (form) => {

	let objetivo = form.goalStrength.map((g) => {
		return { idObjetivoFortalecimientoPlan: g.id, validado: g.validado, habilitarRegistro: g.habilitarRegistro }
	})

	form.relevantChanges.map((r) => {
		delete r.id
		return r
	})

	form.relevantChangesRemove.map((r) => {
		delete r.id
		return r
	})

	let cambio = Utils.unionArray(form.relevantChanges, form.relevantChangesRemove)
	let fechaInicioEtapa = ""

	if (form.dateStart) {
		fechaInicioEtapa = form.dateStart.slice(0, 10).split('-')
		fechaInicioEtapa = `${fechaInicioEtapa[2]}-${fechaInicioEtapa[1]}-${fechaInicioEtapa[0]}`
	}

	let temp = {
		// nivelIntervencion: form.intervention.nivelIntervencion || null,
		etapa: {
			idEtapa: form.stageStrength
		},
		fechaInicioEtapa: fechaInicioEtapa,
		consultor: {
			idConsultor: form.consultant,
		},
		tipoFortalecimiento: {
			idTipoFortalecimiento: form.typeStrength,
		},
		estatusFortalecimiento: {
			idEstatusFortalecimiento: form.statusStrength,
		},
		prioritario: form.checkedPriority,
		tipoFortalecimientoGrupo: {
			temaCapacitacion: form.trainingTopic || "",
			asistencia: form.assistance || "",
			tipoConocimientoAdquiridoAsistencia: {
				idTipoConocimientoAdquirido: form.acquiredKnowledge || null
			},
			calidadServicio: form.qualityService || "",
			otro: form.other || "",
			tipoConocimientoAdquiridoOtro: {
				idTipoConocimientoAdquirido: form.noLabel || null,
			}
		},
		objetivos: { objetivo },
		cambiosRelevantesIntervencion: { cambio },
		objetivosFortalecimiento: form.goalStrengthArea,
		cierreEtapa: /*form.closeStage || false*/null,
		idEvaluacion: form.idEvaluacion,
		idDonataria: form.idDonataria,
		idCorrida: form.idCorrida
	}

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/saveData',
			method: 'POST',
			data: { ...temp },
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, "Bpm": sessionStorage.bpm_token, 'uid': sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_SAVE_DATA, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const sendMail = () => {

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/sendMail',
			method: 'POST',
			data: {},
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_SEND_MAIL, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const closeProcess = () => {

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/closeProcess',
			method: 'POST',
			data: {},
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_CLOSE_PROCESS, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const saveObjectivesAndPlans = (form) => {

	let fechaCompromiso

	if (form.commitmentDate) {
		fechaCompromiso = form.commitmentDate.slice(0, 10).split('-')
		fechaCompromiso = `${fechaCompromiso[2]}-${fechaCompromiso[1]}-${fechaCompromiso[0]}`
	}

	let temp = {
		id: form.idObjective || null,
		idEtapa: form.stageStrength || null,
		variable: { id: form.variable },
		objetivoFortalecimiento: form.objectivesStrength || null,
		fechaCompromiso: fechaCompromiso ? fechaCompromiso : null,
		// fechaConclusionEntrega: null,
		// retrasoEntregables: null,
		tecnicasHerramientaRecomendada: form.recommendedTechnique || null,
		// documento: {
		//     deleted: null,
		//     fechaCreacion: null,
		//     autor: null,
		//     fechaUltimaModificacion: null,
		//     autorUltimaModificacion: null,
		//     idDocumento: null,
		//     nombre: null,
		//     rutaAcceso: null,
		//     dropboxId: null,
		//     descripcion: null,
		//     urlPermanente: null,
		//     tipoDocumento: null
		// },
		recomendaciones: form.recommendations || null,
		// validado: false,
		habilitarRegistro: form.habilitarRegistro
		// deleted: null
	}

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: form.idObjective ? 'api/updateObjectivesAndPlans' : 'api/saveObjectivesAndPlans',
			method: 'POST',
			data: { ...temp },
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const deleteObjectivesAndPlans = (idObjetivo) => {

	return (dispatch) => {
		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/deleteObjectivesAndPlans',
			method: 'POST',
			data: { idObjetivo },
			headers: Object.assign({ 'Authorization': sessionStorage.access_token, 'uid': sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.datas
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const clearObjectives = () => {
	return (dispatch) => {
		dispatch({ type: ACTION_GET_OBJECTIVES, Obj: { objetivos: { objetivo: [] }, porcentajeAvancePlanTrabajo: 0, porcentajeValidacionEntregables: 0 } })
		return Promise.resolve()
	}
}



// WEBPACK FOOTER //
// ./src/modules/Grantees/Evaluation/MonitoringStrength.js